import { render, staticRenderFns } from "./consignmentDelivery.vue?vue&type=template&id=132e271b&scoped=true&"
import script from "./consignmentDelivery.vue?vue&type=script&lang=js&"
export * from "./consignmentDelivery.vue?vue&type=script&lang=js&"
import style0 from "./consignmentDelivery.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./consignmentDelivery.vue?vue&type=style&index=1&id=132e271b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132e271b",
  null
  
)

component.options.__file = "consignmentDelivery.vue"
export default component.exports